module.exports = __webpack_public_path__ + "img/dw3.5c1fe12e.jpg";